import { Link } from 'react-router-dom';
import { ROUTES } from '@app/router/routes';

const MemberNotificationBanner = ({ message, onDismiss }) => {
  if (!message) return null;
  return (
    <div className="bg-accent-red border-t border-accent-red/15 px-4 py-2 flex items-center gap-2">
      <span className="material-symbols-outlined text-white text-base flex-shrink-0" style={{ fontVariationSettings: "'FILL' 1" }}>info</span>
      <p className="text-xs text-white flex-1 leading-snug">{message}</p>
      <Link to={ROUTES.REGISTER} className="text-xs text-white font-semibold whitespace-nowrap underline flex-shrink-0">立即註冊</Link>
      <button className="flex-shrink-0 ml-1" onClick={onDismiss}>
        <span className="material-symbols-outlined text-white text-base">close</span>
      </button>
    </div>
  );
};

export default MemberNotificationBanner;
